/**
 * Slides the `lastVisitedLocation` expiry forward on every visit.
 *
 * The cookie carries an explicit 1-year maxAge (CIN-689), but setValue only writes it
 * when the cinema actually changes — so without this the expiry would be fixed to the
 * last change and a visitor who always opens the same cinema would still lose the
 * remembered location once the year elapsed.
 *
 * Must stay ordered after cleanupOldCookies.client.ts (plugins load in filename order,
 * "c" before "r"): a leftover domain-scoped cookie of the same name — migration debris
 * from CIN-189, see useLastVisitedLocationCookie.ts — shadows the host-only one, and
 * refreshing a shadowed value would re-persist it over the user's actual choice.
 * refreshExpiry bails out on its own when it sees the name twice, so this is defence in
 * depth rather than a hard dependency — which matters, because the cleanup plugin no-ops
 * in environments without COOKIES_DOMAIN.
 */
import { useLastVisitedLocationCookie } from "~/composables/useLastVisitedLocationCookie";

export default defineNuxtPlugin(() => {
  if (import.meta.server) return;

  useLastVisitedLocationCookie().refreshExpiry();
});
